import React from 'react';
import {push} from 'connected-react-router';
import {userLogout} from "../../actions/authActions";
import {changeLanguage} from '../../actions/commonsActions';
import {
	Nav,
	NavItem,
	NavLink,
	Navbar,
	NavbarBrand,
	Collapse,
	UncontrolledDropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
	Dropdown,
	Label,
	Input, Button
} from 'reactstrap';
import {GUEST, USER_ROLES, COMPANY_ADMIN, PAGINATION_DEFAULT_LIMIT} from '../../helpers/constants';
import ReactFlagsSelect from 'react-flags-select';
import {languageModel} from '../../helpers/LanguageModel';
import 'react-flags-select/css/react-flags-select.css';

import './header.css';

/*--------------------------------------------------------------------------------*/
/* Import images which are need for the HEADER                                    */
/*--------------------------------------------------------------------------------*/
import logodarkicon from '../../assets/images/logo-icon.png';
import logolighticon from '../../assets/images/logo-light-icon.png';
import logodarktext from '../../assets/images/logo-text.png';
import logolighttext from '../../assets/images/logo-light-text.png';
import profilephoto from '../../assets/images/users/1.jpg';
import connect from 'react-redux/es/connect/connect';
import {fetchCompanies} from '../../actions/companyActions';
import {fetchNewAlertNotifications, changeUpdatesStatus} from '../../actions/alertActions';
import {I18n} from '../../I18n/components/header';
import {declOfNum} from '../../helpers/declOfNum';

class Header extends React.Component {
	constructor(props) {
		super(props);
		this.toggle = this.toggle.bind(this);
		this.showMobilemenu = this.showMobilemenu.bind(this);
		this.sidebarHandler = this.sidebarHandler.bind(this);
		this.state = {
			isOpen: false,
			lang: '',
			notifyDropdownOpen: false
		};
	}

	componentDidMount() {
		console.log('mount header');
		let activeLang = '';
		console.log(this.props.lang);
		switch (languageModel.getLocalStorageLanguage()) {
			case 'ua':
			case 'ru':
			{
				activeLang = 'RU';
				break;
			}
			case 'en':
			{
				activeLang = 'US';
				break;
			}
			case 'sk':
			{
				activeLang = 'SK';
				break;
			}
		}
		this.setState({
			lang: activeLang
		}, () => {
			if (this.props.authority === COMPANY_ADMIN) {
				this.props.fetchNewAlertNotifications({
					companyId: this.props.companies[0].id,
					page: 0,
					limit: PAGINATION_DEFAULT_LIMIT,
				}).catch(error => {console.log(error)});
			}
		});
	}

	/*--------------------------------------------------------------------------------*/
	/*To open NAVBAR in MOBILE VIEW                                                   */

	/*--------------------------------------------------------------------------------*/
	toggle() {
		this.setState({
			isOpen: !this.state.isOpen
		});
	}

	/*--------------------------------------------------------------------------------*/
	/*To open SIDEBAR-MENU in MOBILE VIEW                                             */

	/*--------------------------------------------------------------------------------*/
	showMobilemenu() {
		document.getElementById('main-wrapper').classList.toggle('show-sidebar');
	}

	// onLangChange = event => {
	// 	const lang = event.target.value;
	// 	event.preventDefault();
	// 	this.setState({
	// 		lang: lang
	// 	}, () => {
	// 		localStorage.setItem('userLang', lang)
	// 		this.props.changeLanguage(lang)
	// 	});
	// };

	onLangChange = lang => {
		let activeLang = '';
		switch (lang.toLowerCase()) {
			case 'ua':
			case 'ru':
			{
				activeLang = 'ru';
				break;
			}
			case 'us':
			{
				activeLang = 'en';
				break;
			}
			case 'sk':
			{
				activeLang = 'sk';
				break;
			}
		}
		this.setState({
			lang: lang
		}, () => {
			//localStorage.setItem('userLang', activeLang);
			this.props.changeLanguage(activeLang);
			languageModel.changeLanguage(activeLang);
		});

	};

	sidebarHandler = () => {
		let element = document.getElementById('main-wrapper');
		switch (this.props.data.settings[0].sidebartype) {
		case 'full':
		case 'iconbar':
			element.classList.toggle('mini-sidebar');
			if (element.classList.contains('mini-sidebar')) {
				element.setAttribute('data-sidebartype', 'mini-sidebar');
			} else {
				element.setAttribute(
					'data-sidebartype',
					this.props.data.settings[0].sidebartype
				);
			}
			break;

		case 'overlay':
		case 'mini-sidebar':
			element.classList.toggle('full');
			if (element.classList.contains('full')) {
				element.setAttribute('data-sidebartype', 'full');
			} else {
				element.setAttribute(
					'data-sidebartype',
					this.props.data.settings[0].sidebartype
				);
			}
			break;

		default:
		}
	};

	logout = event => {
		event.preventDefault();
		this.props.userLogout();
		this.props.changeLocation('/');
	};

	toggleNotifyDropdown = () => {
		this.setState(prevState => ({
			notifyDropdownOpen: !prevState.notifyDropdownOpen
		}));
	};

	redirectToAlerts = event => {
		event.preventDefault();
		this.setState(prevState => ({
			notifyDropdownOpen: !prevState.notifyDropdownOpen
		}), () => {
			this.props.changeLocation('/dashboard/alerts');
		});
	};

	confirmAllHandler = async () => {
		try {
			await this.props.confirmAllUpdates({
				companyId: this.props.companies[0].id ? this.props.companies[0].id : null,
				type: 'ACCEPTED',
				userEmail: this.props.currentUser.email
			});
			await this.props.fetchNewAlertNotifications({
				companyId: this.props.companies[0].id,
				page: 0,
				limit: PAGINATION_DEFAULT_LIMIT,
			});
			this.toggleNotifyDropdown()
		}
		catch (error) {
			console.log(error)
		}
	};

	declineAllHandler = async () => {
		try {
			await this.props.declineAllUpdates({
				companyId: this.props.companies[0].id ? this.props.companies[0].id : null,
				type: 'DECLINED',
				userEmail: this.props.currentUser.email
			});
			await this.props.fetchNewAlertNotifications({
				companyId: this.props.companies[0].id,
				page: 0,
				limit: PAGINATION_DEFAULT_LIMIT,
			});
			this.toggleNotifyDropdown()
		}
		catch (error) {
			console.log(error)
		}
	};

	renderFlagSelector = activeLang => {
		if (activeLang[0] === "R" && activeLang[1] === "U") {
			activeLang = "UA";
		}
		return activeLang ? <ReactFlagsSelect
			className="menu-flags"
			defaultCountry={activeLang}
			countries={["UA", "US", "SK"]}
			customLabels={{"UA": "UA", "US": "EN", "SK": "SK"}}
			onSelect={this.onLangChange}
			selectedSize={12}
			optionsSize={12}
		/> : null;
	}

	render() {
		console.log('render header', this.props);
		const {currentUser, authority, lang, newAlertsTotal, newAlertsLoading, location} = this.props;
		return (
			<header className="topbar navbarbg" data-navbarbg={this.props.data.settings[0].navbarbg}>
				<Navbar className={"top-navbar " + (this.props.data.settings[0].navbarbg === "skin6" ? 'navbar-light' : 'navbar-dark')}
						expand="md">
					<div className="navbar-header" id="logobg" data-logobg={this.props.data.settings[0].logobg}>
						{/*--------------------------------------------------------------------------------*/}
						{/* Mobile View Toggler  [visible only after 768px screen]                         */}
						{/*--------------------------------------------------------------------------------*/}
						<a className="nav-toggler d-block d-md-none" onClick={this.showMobilemenu}>
							<i className="ti-menu ti-close"/>
						</a>
						{/*--------------------------------------------------------------------------------*/}
						{/* Logos Or Icon will be goes here for Light Layout && Dark Layout                */}
						{/*--------------------------------------------------------------------------------*/}
						<NavbarBrand href="/">
							<b className="logo-icon">
								<img src={logodarkicon} alt="homepage" className="dark-logo"/>
								<img
									src={logolighticon}
									alt="homepage"
									className="light-logo"
								/>
							</b>
							<span className="logo-text">
								Package Assistant
              				</span>
						</NavbarBrand>
						{/*--------------------------------------------------------------------------------*/}
						{/* Mobile View Toggler  [visible only after 768px screen]                         */}
						{/*--------------------------------------------------------------------------------*/}
						<a className="topbartoggler d-block d-md-none" onClick={this.toggle}>
							<i className="ti-more"/>
						</a>
					</div>
					<Collapse className="navbarbg" isOpen={this.state.isOpen} navbar data-navbarbg={this.props.data.settings[0].navbarbg}>
						<Nav className="float-left" navbar>
							<NavItem>
								<NavLink href="#" className="d-none d-md-block" onClick={this.sidebarHandler}>
									<i className="ti-menu"/>
								</NavLink>
							</NavItem>
						</Nav>
						<Nav className="ml-auto float-right" navbar>
							<Dropdown
                                isOpen={this.state.notifyDropdownOpen}
                                toggle={newAlertsTotal !== 0 && location.pathname !== '/dashboard/alerts' ? this.toggleNotifyDropdown : () => {}}
                                nav inNavbar
                            >
								<DropdownToggle nav caret>
									<i className={newAlertsTotal !== 0 ?
											"mdi mdi-bell font-24 bell-notification new" : "mdi mdi-bell font-24 bell-notification"
										}
									/>
								</DropdownToggle>
								<DropdownMenu right className="mailbox">
                  					<span className="with-arrow">
										<span className="mailbox-arrow"></span>
                  					</span>
									<div className="mailbox-top d-flex no-block align-items-center p-3 text-white mb-2">
										<div >
											<h5 className="mb-0">{I18n[lang].notifications}</h5>
										</div>
									</div>
									<div className="message-center notifications">
										{
											newAlertsTotal !== 0 && location.pathname !== '/dashboard/alerts' ? (
												<div className="message-item">
													<div className="mail-content">
														<h5 className="message-title">{I18n[lang].updates}</h5>
														<div className="mail-desc">
                                                            { newAlertsTotal } {declOfNum(121, [
															I18n[lang].text_updates_three,
															I18n[lang].text_updates_one,
															I18n[lang].text_updates_two
														])}
														</div>
														<a className="message-link message-link--more" href=""
														   onClick={this.redirectToAlerts}>
															<strong>{I18n[lang].check_all}</strong>{' '}
															<i className="fa fa-angle-right"/>
														</a>
														<div className="message-item__btns">
															<Button
																color="secondary"
																type="button"
																size="sm"
																onClick={this.declineAllHandler}
															>
																{I18n[lang].cancel}
															</Button>
															<Button
																color="primary"
																type="button"
																size="sm"
																onClick={this.confirmAllHandler}
															>{I18n[lang].update}
															</Button>
														</div>
													</div>
												</div>
											) : null
										}
									</div>
								</DropdownMenu>
							</Dropdown>
							{this.renderFlagSelector(this.state.lang)}
							<UncontrolledDropdown nav inNavbar>
								<DropdownToggle nav caret className="pro-pic">
									<img
										src={profilephoto}
										alt="user"
										className="rounded-circle"
										width="31"
									/>
								</DropdownToggle>
								<DropdownMenu right className="user-dd">
                  					<span className="with-arrow">
										<span className="bg-secondary"></span>
                  					</span>
									<div className="d-flex no-block align-items-center p-3 bg-secondary text-white mb-2">
										<div className="">
											<img
												src={profilephoto}
												alt="user"
												className="rounded-circle"
												width="60"
											/>
										</div>
										<div className="ml-2">
											<h4 className="mb-0">{currentUser.user_name}</h4>
											<p className=" mb-0">{currentUser.email}</p>
										</div>
									</div>
									<DropdownItem>
										<i className="ti-user mr-1 ml-1"/> {USER_ROLES[authority]}
									</DropdownItem>
									<DropdownItem href="/pages/login" onClick={this.logout}>
										<i className="fa fa-power-off mr-1 ml-1"/> Logout
									</DropdownItem>
									<DropdownItem divider/>
								</DropdownMenu>
							</UncontrolledDropdown>
						</Nav>
					</Collapse>
				</Navbar>
			</header>
		);
	}
}

const mapDispatchToProps = dispatch => {
	return {
		userLogout: () => dispatch(userLogout()),
		changeLocation: (url) => dispatch(push(url)),
		changeLanguage: lang => dispatch(changeLanguage(lang)),
		fetchCompanies: (query) => dispatch(fetchCompanies(query)),
		fetchNewAlertNotifications: (query) => dispatch(fetchNewAlertNotifications(query)),
		confirmAllUpdates: (query) => dispatch(changeUpdatesStatus(query)),
		declineAllUpdates: (query) => dispatch(changeUpdatesStatus(query)),
	};
};

const mapStateToProps = state => ({
	isAuth: state.isAuth,
	currentUser: state.currentUser,
	authority: state.isAuth && state.currentUser ? state.currentUser.roles[0].authority : GUEST, //SUPER_ADMIN
	companies: state.companiesReducer.companies,
	newAlertsLoading: state.alertNewNotificationsReducer.loading,
	newAlertsTotal: state.alertNewNotificationsReducer.totalElements,
	lang: state.languageReducer.lang
});
export default connect(mapStateToProps, mapDispatchToProps)(Header)



// WEBPACK FOOTER //
// ./src/components/Header/header.jsx